import { IPanelProps, Panel } from "core/decorators/Panel";
import { Query } from 'core/api/typedQuery';
import React from "react";
import { Entity, Field } from "typegraph";
import UserRegistrationFormConfig from "./UserRegistrationForm";
import labelProvider from './UserRegistration.labels';
import { FragmentLayout } from "core/components/FragmentLayout";
import * as displayFragments from "./displayFragments";
import * as actionFragments from "./actionFragments";
import { BlockView } from "common/views/block/BlockView.view";



const courseFragments = {
    ...displayFragments,
    ...actionFragments,
};

export interface IState{
   user?:any
   error?:any
   properties?:any
}
export class SelectOptions {
    @Field()
    public label: string;
    @Field()
    public value: number
}

export class Property{
    @Field()
    public id: number;
    @Field()
    public type: string;  
    @Field()
    public  propsName: string;
    @Field()
    public  displayName: string;
    @Field()
    public  required: boolean;
    @Field()
    public  validationRegex: string;
    @Field()
    public  lob: boolean; 
    @Field()
    public  mutipleValues: boolean;
    @Field()
    public  sortIndex: number;
    @Field()
    public  properties: string;
    @Field()
    public  template: boolean;
    @Field()
    public  viewOnly: boolean;
    @Field()
    public  internal: boolean;
    @Field()
    public  hidden: boolean;
    @Field()
    public  encrypted: boolean;
}

@Entity({one: 'getFormData'})
class GetFormData{
    @Field({entity: SelectOptions})
    public roles: SelectOptions[];

    
    @Field({entity: SelectOptions})
    public groups: SelectOptions[];

    @Field({entity: Property})
    public userPropertyValue:Property[];

    @Field()
    public gdprPolicyMessage:string
}

export class IUserRegistrationFragmetProps{
    data: GetFormData;
    onChange: (e: any, selectList?:SelectOptions[], name?:string) => void;
    state: IState;
    onSubmit: () => void;
    onCustPropChange: (e: any, selectList?:SelectOptions[], name?:string) => void;
    onErroStateChange: (name: string, value: boolean) => void;
    errorStateRest: () => void;
}

export class ICustomFragmentProps{
    
}

const  GetFormDataQuery= Query.queryOne<GetFormData, any>(GetFormData);



@Panel({id: "user-registrationForm", configClass: UserRegistrationFormConfig,  labelProvider, pageParams: true})
export default class UserRegistrationForm extends React.Component<IPanelProps<UserRegistrationFormConfig>, IState> {

    constructor(props: IPanelProps<UserRegistrationFormConfig>) {
		super(props);
        this.state ={
            user: {},
            properties: {}
        }
	}

    handleInputChange = (event, selectList?:SelectOptions[], name?:string)=> {
        if(name && selectList){
            let value = selectList.map(({ value }) => value)
            this.setUserState(name, value);
        } else{
            const target = event.target;
            const value = target.type === 'checkbox' ? target.checked : target.value;
            const name = target.name;
            this.setUserState(name, value);
        }   
    }

    handleErroStateChange = (name, value)=> {
        this.setState(prevState => {
            let error = {...prevState.error};
            error[name]= value
             return {error}
      }) 
    }

    errorStateRest = ()=>{
              this.setState(prevState => {
            let error = {...prevState.error};
            error= {}
             return {error}
      }) 
    }

    handleCustInputChange = (name, value)=> {
        this.setState(prevState => {
            let properties = {...prevState.properties};
            properties[name]= value
             return {properties}
      }) 
    }



      setUserState= (name: string, value: string| number[]) =>{  
        this.setState(prevState => {
            let user = {...prevState.user};
             user[name]= value
             return {user}
      })
      }


      
	public render() {
        const {config}= this.props;

        return(
            <GetFormDataQuery
					params={{ id: "id" }}
                    >
                {({ data, loading }) => {
                    let custom={};
                    	if(data!=null){
                            return(
                                <BlockView key="userReg"  viewKey="userReg">
                                    <FragmentLayout
                                            fragments={courseFragments}
                                            layout= {config.userLayout}
                                            props={{
                                                data: data,
                                                onChange: this.handleInputChange,
                                                onCustPropChange: this.handleCustInputChange,
                                                state: this.state,
                                                onErroStateChange: this.handleErroStateChange,
                                                errorStateRest: this.errorStateRest
                                            }}
                                            
                                        />
                                </BlockView>
                        )                            
                    }

                }}
        </GetFormDataQuery>
        );
    }

}



// WEBPACK FOOTER //
// ./src/panels/userRegistration/UserRegistrationForm.panel.tsx